module.exports = __webpack_public_path__ + "static/media/search-keyword-suggestions.0b556124.png";